//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getZbConfig } from '@/api/zhigongxiaojia.js'
// import { getConfig } from '@/api/wx.js'
export default {
  name: 'weiyitong',
  props: {},
  data () {
    return {}
  },
  created () { },
  mounted () {
    var element = document.createElement('script')
    element.src = 'http://res.wx.qq.com/open/js/jweixin-1.2.0.js'
    var element2 = document.createElement('script')
    element2.src = 'https://open.work.weixin.qq.com/wwopen/js/jwxwork-1.0.0.js'
    document.body.appendChild(element)
    document.body.appendChild(element2)
  },
  methods: {
    open () {
      // 微信权限配置
      let ua = window.navigator.userAgent.toLowerCase()
      // alert('ua:' + ua)
      let href = window.location.href.split('#')[0]
      if (
        ua.match(/MicroMessenger/i) == 'micromessenger' &&
        ua.match(/wxwork/i) == 'wxwork'
      ) {
        href = window.location.href.split('#')[0]
        // alert('企业微信客户端')
      } else if (ua.match(/micromessenger/i) == 'micromessenger') {
        href = this.$store.state.user.wechatSignUrl
        // alert('微信客户端')
      }
      getZbConfig({
        url: href
      }).then(res => {
        console.log(wx)
        wx.agentConfig({
          // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          corpid: res.obj.corpid, // 必填，公众号的唯一标识
          agentid: res.obj.agentid,
          timestamp: res.obj.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.obj.nonceStr, // 必填，生成签名的随机串
          signature: res.obj.signature, // 必填，签名，见附录1
          jsApiList: ['launchMiniprogram'], // 必填，传入需要使用的接口名称
          success: function (res) {
            wx.invoke('launchMiniprogram', {
              'appid': 'wx11e3659ea9aaf3fc', // 需跳转的小程序appid
              'path': 'pages/module/module?sourceCode=ZGYZJTGH' // 所需跳转的小程序内页面路径及参数。非必填
            }, function (res) {
              if (res.err_msg == 'launchMiniprogram:ok') {
                // 正常
                console.log('成功', res)
              } else {
                console.log('失败', res)
                // 错误处理
              }
            })
            // 回调
            console.log('agentconfigsuc', res)
          },
          fail: function (res) {
            console.log('agentconfigerr', res)
            if (res.errMsg.indexOf('function not exist') > -1) {
              alert('版本过低请升级')
            }
          }
        })
      })
    }
  }
}
